import React from 'react';
import { AccountIcon, BusinessCategoryIcon, BusinessIreferIcon, HelpIcon, InviteAReferrerIcon, ReferralIcon, ReferReferUsIcon, ReferUsNetworkIcon, SetupIcon, SmsIcon, SocialMediaIcon } from "../icons/icons"
import setup from "../images/icon/Isolation_Mode.svg";
import Referrals from "../images/icon/My Referrals.svg";
import BusinessCategory from "../images/icon/BusinessCategory.svg";
import MyReferrers from "../images/icon/My Referrers.svg";
import Companies from "../images/icon/Companies I Refer.svg";
import myNetwork from "../images/icon/myNetwork.png";
import AddReferral from "../images/icon/addrefer.svg";
import ReferUS from "../images/icon/Refer ReferUS.svg";
import Invite from "../images/icon/Invite A Referrer.svg";
import Social from "../images/icon/socialmedia.svg";
import Network from "../images/icon/ReferUS Network.svg";
import account from "../images/icon/Account.svg";
import help from "../images/icon/help.svg";
import Sms from "../images/icon/Sms.svg"

import { faqHelpImages, faqHelpImagesQ10, faqHelpImagesQ11, faqHelpImagesQ12, faqHelpImagesQ13, faqHelpImagesQ14, faqHelpImagesQ2, faqHelpImagesQ3, faqHelpImagesQ7, faqHelpImagesQ8, faqHelpImagesQ9 } from './helpImages';

export const helpFAQS = [
    {
        question: 'How does ReferUs work?',
        answer: (
            <>
                {faqHelpImages.slice(0, 7).map((image, index) => (
                    <div key={index} style={{ marginTop: '10px' }}>
                        <img
                            src={image}
                            alt="How ReferUs Works"
                            style={{ width: '100%' }}
                            onContextMenu={(e) => e.preventDefault()}
                        />
                    </div>
                ))}
            </>
        ),
    },
    {
        question: 'How do I set up my ReferUs system?',
        children: [
            {
                question: 'Step a - Setting up your Logo',
                answer: (
                    <>
                        <p>
                            When you register to purchase the ReferUs System, you will complete a sign-up form. After completing this form, the system will automatically open a webpage that allows you to update your username and password. Once you have updated your details, the system will take you to the Set-Up page. This is where you upload your logo, enter your business details, and set up rewards for your referrers.
                        </p>
                        <img src={faqHelpImagesQ2[0]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
                    </>
                ),
            },
            {
                question: 'Step b - Trouble shooting- my logo doesn’t look how it should. How do I fix it?',
                answer: (
                    <>
                        <p>
                        If you encounter any issues uploading your logo, feel free to reach out to us. We're happy to assist in formatting it to ensure it looks clean and professional on your promotional page.
                        </p>
                        <img src={faqHelpImagesQ2[1]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
                        <br />
                        <p>
                        You can colour the header of your promotional page to suit your logos colour by using the colour selector as below.
                        </p>
                        <img src={faqHelpImagesQ2[2]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
                    </>
                ),
            },
            {
                question: 'Step c - Entering your company details',
                answer: (
                    <>
                        <p>
                        By entering your company details the system will create a unique URL and QR Code for your business. This code is how a referrer and referral are linked to your system. You also use this code to promote your promotional page and to obtain referrers and referrals.
                        </p>
                        <img src={faqHelpImagesQ2[3]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
                    </>
                ),
            },
            {
                question: 'Step d and e - Selecting your business category and entering a description of your business.',
                answer: (
                    <>
                        <p>
                        When setting up your ReferUs System you will be asked to select a category that suits your business best. This category section will be used in different search fields throughout the system including the ReferUs Network section.
                        </p>
                        <img src={faqHelpImagesQ2[4]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
                    </>
                ),
            },
            {
                question: 'Step f and g - Entering your business description and services',
                answer: (
                    <>
                        <p>
                        When you enter your business description and services, these details enter here will be seen on your promotional page. You can build a reward for each service in the third step of this set up process “Rewards”. It’s a good idea to not have more than 4 services.
                        </p>
                        <img src={faqHelpImagesQ2[5]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
                    </>
                ),
            },
            {
                question: 'Step h - Entering your Business Address',
                answer: (
                    <>
                        <p>
                        You can enter a business address if you like, this is not a mandatory field as some businesses may work from home and may not want their address in the system as this address will be on your promotional page. You can have the choice to either enter an address and upload a map or upload a picture of even upload a video (as long as its hosted on YouTube).
                        </p>
                        <img src={faqHelpImagesQ2[6]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
                    </>
                ),
            },
            {
                question: 'Step i - How to set up a reward?',
                answer: (
                    <>
                        <p>
                        Your rewards are the most important part of the ReferUs set up process, the better the reward the more likely a referrer will send you a referral.
                        </p>
                        <img src={faqHelpImagesQ2[7]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
                        <br />
                        <p>
                        Select Add Reward. You can select the reward as either No Reward, Commission on the sale, a Cash Reward or a Voucher or Freebie. These rewards can be changed at anytime. 
                        <br />
                        Once you select the type of reward the system will open a corresponding dropdown list
                        </p>
                        <img src={faqHelpImagesQ2[8]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
                    </>
                ),
            },
            {
                question: 'Step j - Reward Register',
                answer: (
                    <>
                        <p>
                        Rewards created will be seen in your Rewards Register and can be edited at any time.
                        </p>
                        <img src={faqHelpImagesQ2[9]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
                    </>
                ),
            },
            {
                question: 'The Dashboard - Welcome to ReferUs',
                answer: (
                    <>
                        <p>
                        Once you have completed the ReferUs Setup process you as a “ReferUs” Business will see the below dashboard. A person who becomes a referrer for your business will not see the “Invite a Referrer” or “My Referrers” page but will see all the other icons. Please remember they also get your unique URL Promotional Page for them to post on their social media. It’s a great idea to keep in contact with your referrers as they are the ones about to help build your business.
                        </p>
                        <img src={faqHelpImagesQ2[10]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
                    </>
                ),
            },
        ],
    },    
    {
        question: 'Inviting Referrers',
        children: [
            {
                question: 'Step a - How do I invite a Referrer?',
                answer: (
                    <>
                        <p>
                          Use this icon to invite a person to become a Referrer for your business. You can also invite multiple people to become Referrers for you via the "My Referrers" register.
                        </p>
                        <img src={faqHelpImagesQ3[0]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
                    </>
                ),
            },
            {
                question: 'Step b - How do I use invite multiple people at the same time?',  
                answer: (
                    <>
                    </>
                )
            },
            {
                question: 'Step c - How do I pay a Referrer?',  
                answer: (
                    <>
                    </>
                )
            }
        ]
    },
    {
        question: 'How to I manage My Referrals?',  
        answer: (
            <>
              <p>This list shows all your referrals, sent either by one of your current referrers or through your social media post via your promotional page. Be sure to reach out to each new referral within 24 hours to ensure prompt communication. This is a list of everyone who has become a referrer for your business. You can invite new referrers directly through this register or send multiple invitations at once by uploading your database.</p>
              <img src={faqHelpImagesQ3[1]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
            </>
        ),
        children : [
            {
                question: 'Step a - My Referrals Register',  
                answer: (
                    <>
                    </>
                )
            }
        ]
    },
    {
        question: 'My Referrers',  
        answer: (
            <>
              <p>This is a list of everyone who has become a referrer for your business. You can invite new referrers directly through this register or send multiple invitations at once by uploading your database.</p>
              <img src={faqHelpImagesQ3[2]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
            </>
        ),
        children : [
            {
                question: 'Step a - My Referrers Register',  
                answer: (
                    <>
                    </>
                )
            }
        ]
    },
    {
        question: 'Refer ReferUs',  
        answer: (
            <>
              <p>If you love ReferUs why not Refer ReferUs. For every successful yearly system referred you will receive $50.00. If the new business pays monthly you will be paid $25.00 at the end of their first two six months periods.</p>
              <img src={faqHelpImagesQ3[3]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
            </>
        ),
        children : [
            {
                question: 'Step a - Sending ReferUs a Referral',  
                answer: (
                    <>
                      <ol>
                        <li>Enter their business name</li>
                        <li>This is important make sure to enter their email address!</li>
                        <li>Enter their mobile (non-mandatory) but it is preferred to make it easier for the business to contact the referral.</li>
                        <li>Enter their contact name</li>
                        <li>Enter their position (non-mandatory). This will give the business an insight on who they are talking to i.e: is it the owner or just a employee.</li>
                        <li>Their address so the business can identify if they can actually service this referral.</li>
                        <li>Select the Refer button and the referral will be sent to the business but also highlighted in your Referral Register as pending.</li>
                      </ol> 
                      <img src={faqHelpImagesQ3[4]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
                    </>
                )
            }
        ]
    },
    {
        question: 'Business I Refer',  
        answer: (
            <>
              <p>This register is a list of all the businesses you refer for. The great thing about ReferUs is that you can Refer multiple businesses via your ReferUs system. Its a great way to earn passive income</p>
              <img src={faqHelpImagesQ7[0]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
            </>
        ),
        children : [
            {
                question: 'Step a - How do I use the Business I Refer Register?',  
                answer: (
                    <>
                    </>
                )
            },
            {
                question: 'Step b - How do I refer a referral to a business I refer for?',  
                answer: (
                    <>
                       <ul>
                            <li>Go to “Businesses I Refer” and select the business to which you wish to refer a customer.</li>
                            <li>Fill in the referral details and submit to track the referral process.</li>
                        </ul>


                    </>
                )
            },
            {
                question: 'Step c - Where do I see if a business I sent a referral to was successful?', 
                answer: (
                    <>
                       <ul>
                            <li>Under “Business I Refer Register,” locate the specific business and track the status in the “Referral Outcome” section.</li>
                        </ul>
                    </>
                )
            }
        ]
    },
    {
        question: 'Send Referral',  
        answer: (
            <>
              <p>Using ReferUs as a business you can also refer other businesses that you have become a referrer for. You can see the list of businesses on the ReferUs platform and become a referrer for then via the ReferUs Network Register. You can become a Referrer for as many businesses as you like.</p>
              <img src={faqHelpImagesQ8[0]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
            </>
        ),
        children : [
            {
                question: 'Step a - How do I send a referral, and what happens next?',  
                answer: (
                    <>
                        <ul>
                            <li>Access the “Send Referral” feature, enter the referral details, and submit.</li>
                            <li>Once sent, the system notifies both the business and the referrer; you can track the referral’s status under “My Referrals.”</li>
                        </ul>
                        <img src={faqHelpImagesQ8[0]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
                     </>
                ) 
            }
        ]
    },
    {
        question: 'The ReferUs Network',  
        answer: (
            <>
              <p>The ReferUs Network is a list of all the businesses on the ReferUs Platform. You will also be able to see what other businesses rewards are, to either become a referrer for them or maybe modify your reward via the Set Up Register.</p>
              <img src={faqHelpImagesQ9[0]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
            </>
        ),
        children : [
            {
                question: 'Step a - How do I use the ReferUs Network Register?',  
                answer: (
                    <>
                      <ol>
                        <li>You can search the Network by a business name.</li>
                        <li>You can search by a category</li>
                        <li>You can search by postcode</li>
                        <li>Make sure to select search</li>
                        <li>You can reset your search</li>
                        <li>As a business in the ReferUs Network your business category, name, logo and description will be seen on this network. By selecting View More button on each businesses tile the system will take you to that businesses promotional page.</li>
                      </ol>
                      <img src={faqHelpImagesQ9[1]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
                    </>
                )
            },
        ]
    },
    {
        question: 'Social Media',  
        answer: (
            <>
              <p>Use this section to post your promotional page to all your social media outlets. In this register you will also find your unique URL which open your promotional page. You will also find your unique QR Code which again open your promotional page to build your army of referrers.</p>
              <img src={faqHelpImagesQ10[0]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
            </>
        ),
        children : [
            {
                question: 'Step a - How do I promote on social media to obtain referrers and referrals?',  
                answer: (
                    <>
                      <ul>
                        <li>In the “Social Media Register,” select from a variety of pre-made social media posts or create custom ones.</li>
                        <li>Use the “Share” button to post directly to your social media accounts or copy the link to share manually.</li>
                      </ul>
                      <img src={faqHelpImagesQ10[1]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
                    </>
                )
            }
        ]
    },
    {
        question: 'Promotional Page',  
        answer: (
            <>
              <p>This register highlights your promotional page. It gathers all its information via the 'SetUp" process, so if you would like to update it make sure you go to the "Set Up" process to update it. This page can be either printed out and place throughout your business or go to the "Social Media" to post this Promotional page to your social media platforms.</p>
              <img src={faqHelpImagesQ11[0]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
            </>
        ),
        children : [
            {
                question: 'Step a - How do I use my Promotional page?',  
                answer: (
                    <>
                       <p>By signing up with ReferUs as a business the system will automatically build your very own branded promotional page which you can use to obtain referrers. This Promotional Page is developed via the set up process and can be changed at any time by selecting the setup icon or button in the left hand directory.</p>
                       <ol>
                          <li>Your business logo you uploaded in the first step of the setup process. If the side banner beside your logo are not the correct colour go back to the set up process and select the colour icon next to where you uploaded your logo.</li>
                          <li>Your business name</li>
                          <li>Your address but as mentioned if you do not want your address on your promotional page do not fill in that field</li>
                          <li>The services you entered will also be seen on the promotional page</li>
                          <li>As are your rewards also seen on this promotional page.</li>
                          <li>When a person sees your promotional page on social media they can select the “Become a Referrer” button or scan the QR Code which will take them to your Referrer Signup page. Once signed up they will be seen in the Referrers Register and also receive access to ReferUs as a referrer where they can refer people to your business.</li>
                          <li>You can upload a map of your address but as mentioned if you do not want your address on this page you can either upload a graphic or video. As long as the video is hosted on YouTube.</li>
                       </ol>
                       <img src={faqHelpImagesQ11[1]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
                    </>
                )
            }
        ]
    },
    {
        question: 'Account',  
        answer: (
            <>
              <p>This register is where you can manage your account details. You may need to update your email or phone number etc. You also use this register to see which referrers you need to reward due to a successful referral.</p>
              <img src={faqHelpImagesQ12[0]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
            </>
        ),
        children : [
            {
                question: 'Step a - How do I use the Accounts Register?',  
                answer: (
                    <>
                      <ul>
                        <li>The “Accounts Register” holds all user accounts associated with your ReferUs profile.</li>
                        <li>View or manage account details, update information, and set permissions for other users on your ReferUs account.</li>
                      </ul>
                      <img src={faqHelpImagesQ12[1]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
                    </>
                )
            }
        ]
    },
    {
        question: 'Set Up',  
        answer: (
            <>
              <p>This register is an extremely important register as this register will not only brand your system and mobile application but also develop your very own promotional page.</p>
              <img src={faqHelpImagesQ13[0]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
            </>
        )
    },
    {
        question: 'Help Register',
        answer: (
            <>
              <p>Use this register to learn how to get the most out of your ReferUs system. In this section you will find step by step guides but also short videos from Justin Herald and Phil Bamford Co-Founders of ReferUs on how to build and manage your army of referrers and obtain more referrers.</p>
              <img src={faqHelpImagesQ14[0]} alt="Setting up Logo" style={{ width: '100%', marginTop: '10px' }} onContextMenu={(e) => e.preventDefault()}/>
            </>
        ),  
        children : [
            {
                question: 'Step a - How do I contact ReferUs?',  
                answer: (
                    <>
                      <ul>
                        <li>Access the “Help & Support” section on your dashboard to reach out via chat, email, or phone for any inquiries.</li>
                      </ul>
                    </>
                )
            }
        ]
    }
];


export const socialMediaList = [
    {
        value: "facebook",
        label: "Facebook"
    },
    {
        value: "instagram",
        label: "Instagram"
    },
    {
        value: "linkedIn",
        label: "LinkedIn"
    },
]

// ******* for business admin **************** //
export const sidebarMenuList = [
    {
        id: 1,
        role: [2,3],
        name: 'Invite A Referrer',
        path: '/invite-a-referrer',
        icon: InviteAReferrerIcon()
    },
    {
        id: 2,
        role: [2, 3],
        name: 'My Referrals',
        path: '/my-referrals',
        icon: ReferralIcon()
    },
    {
        id: 3,
        role: [2],
        name: 'My Referrers',
        path: '/my-referrers',
        icon: ReferralIcon()
    },
    {
        id: 4,
        role: [2, 3],
        name: 'Refer ReferUs',
        path: '/refer-referus',
        icon: ReferReferUsIcon()
    },
    {
        id: 5,
        role: [3],
        name: 'Businesses I Refer',
        path: '/business-i-refer',
        icon: BusinessIreferIcon()
    },
    {
        id: 6,
        role: [2],
        name: 'My Network',
        path: '/my-network',
        icon: BusinessIreferIcon()
    },
    {
        id: 7,
        role: [2, 3],
        name: 'Send Referral',
        path: '/send-referral',
        icon: InviteAReferrerIcon()
    },
    {
        id: 8,
        role: [2, 3],
        name: 'ReferUs Network',
        path: '/referus-network',
        icon: ReferUsNetworkIcon()
    },
    {
        id: 9,
        role: [2, 3],
        name: 'Social Media',
        path: '/social-media',
        icon: SocialMediaIcon()
    },
    // {
    //     id: 9,
    //     role: [2],
    //     name: 'Promotional Page',
    //     path: '/businessLink',
    //     icon: LinkIcon() // Uncomment this if you need it
    // },
    {
        id: 10,
        role: [2, 3],
        name: 'Account',
        path: '/account',
        icon: AccountIcon()
    },
    {
        id: 11,
        role: [2],
        name: 'Setup',
        path: '/setup',
        icon: SetupIcon()
    },
    {
        id: 12,
        role: [2, 3],
        name: 'Help',
        path: '/help',
        icon: HelpIcon()
    },
];

// *********** Super admin sidemenu list *************** //
export const superAdminSidebarMenuList = [
    {
        id: 1,
        role: [1],
        name: 'Businesses',
        path: '/super-admin/all-businesses',
        icon: BusinessIreferIcon()
    },
    {
        id: 2,
        role: [1],
        name: 'Refer ReferUs',
        path: '/super-admin/refer-admin-referus',
        icon: ReferReferUsIcon()
    },
    {
        id: 6,
        role: [1],
        name: 'My Referrers',
        path: '/super-admin/my-referrers',
        icon: ReferralIcon()
    },
    {
        id: 7,
        role: [1],
        name: 'My Referrals',
        path: '/super-admin/my-referrals',
        icon: ReferralIcon()
    },
    {
        id: 3,
        role: [1],
        name: 'ReferUs Network',
        path: '/super-admin/referus-network',
        icon: ReferUsNetworkIcon()
    },
    {
        id: 4,
        role: [1],
        name: 'Contact Us',
        path: '/super-admin/contact-us',
        icon: HelpIcon()
    },
    {
        id: 5,
        role: [1],
        name: 'SMS',
        path: '/super-admin/sms',
        icon:  SmsIcon()
    },
    {
        id: 5,
        role: [1],
        name: 'Business Category',
        path: '/super-admin/business-category',
        icon:  BusinessCategoryIcon()
    },
    {
        id: 6,
        role: [1],
        name: 'Platform List',
        path: '/super-admin/platform-list',
        icon: BusinessIreferIcon()
    }
]

export const dashboardItemList = [
    {
        id: 1,
        role: [2,3],
        name: 'Invite A Referrer',
        path: '/invite-a-referrer',
        icon: Invite
    },
    {
        id: 2,
        role: [2,3],
        name: 'My Referrals',
        path: '/my-referrals',
        icon: Referrals
    },
    {
        id: 3,
        role: [2],
        name: 'My Referrers',
        path: '/my-referrers',
        icon: MyReferrers
    },
    {
        id: 4,
        role: [2, 3],
        name: 'Refer ReferUs',
        path: '/refer-referus',
        icon: ReferUS
    },
    {
        id: 5,
        role: [3],
        name: 'Businesses I Refer',
        path: '/business-i-refer',
        icon: Companies
    },
    {
        id: 6,
        role: [2],
        name: 'My Network',
        path: '/my-network',
        icon: myNetwork
    },
    {
        id: 7,
        role: [2, 3],
        name: 'Send Referral',
        path: '/send-referral',
        icon: AddReferral
    },
    {
        id: 8,
        role: [2, 3],
        name: 'ReferUs Network',
        path: '/referus-network',
        icon: Network
    },
    {
        id: 9,
        role: [2, 3],
        name: 'Social Media',
        path: '/social-media',
        icon: Social
    },
    {
        id: 10,
        role: [2],
        name: 'Promotional Page',
        path: '/businessLink',
        icon: setup
    },
    {
        id: 11,
        role: [2, 3],
        name: 'Account',
        path: '/account',
        icon: account
    },
    {
        id: 12,
        role: [2],
        name: 'Setup',
        path: '/setup',
        icon: setup
    },
    {
        id: 13,
        role: [2, 3],
        name: 'Help',
        path: '/help',
        icon: help
    },
];

export const dashboardInfoText:any = [
{"invite-a-referrer": `Use this icon to invite a person to become a Referrer for your business. You can also invite multiple people to become Referrers for you via the "My Referrers" register.`},
{"my-referrals": `This list shows all your referrals, sent either by one of your current referrers or through your social media post via your promotional page. Be sure to reach out to each new referral within 24 hours to ensure prompt communication.
This is a list of everyone who has become a referrer for your business. You can invite new referrers directly through this register or send multiple invitations at once by uploading your database.`},
{"my-referrers": `This is a list of everyone who has become a referrer for your business. You can invite new referrers directly through this register or send multiple invitations at once by uploading your database.`},
{"refer-referus": `If you love ReferUs why not Refer ReferUs. For every successful yearly system referred you will receive $50.00. If the new business pays monthly you will be paid $25.00 at the end of their first two six months periods.`},
{"business-i-refer": `This register is a list of all the businesses you refer for. The great thing about ReferUs is that you can Refer multiple businesses via your ReferUs system. Its a great way to earn passive income.`},
{"send-referral": `Using ReferUs as a business you can also refer other businesses that you have become a referrer for. You can see the list of businesses on the ReferUs platform and become a referrer for then via the ReferUs Network Register. You can become a Referrer for as many businesses as you like.`},
{"referus-network": `The ReferUs Network is a list of all the businesses on the ReferUs Platform. You will be also be able to see what other businesses rewards are, to either become a referrer for them or maybe modify your reward via the Set Up Register.`},
{"social-media": `Use this section to post your promotional page to all your social media outlets. In this register you will also find your unique URL which open your promotional page. You will also find your unique QR Code which again open your promotional page to build your army pof referrers.`},
{"businessLink": `This register highlights your promotional page. It gathers all its information via the 'SetUp" process, so if you would like to update it make sure you go to the "Set Up" process to update it. This page can be either printed out and place throughout your business or go to the "Social Media" to post this Promotional page to your social media platforms.`},
{"account": `This register is where you can manage your account details. You may need to update your email or phone number etc. You also use this register to see which referrers you need to reward due to a successful referral.`},
{"setup": `This register is an extremely important register as this register will not only brand your system and mobile application but also develop your very own promotional page.`},
{"help": `Use this register to learn how to get the most out of your ReferUs system. In this section you will find step by step guides but also short videos from Justin Herald and Phil Bamford Co-Founders of ReferUs on how to build and manage your army of referrers and obtain more referrals.`},
]


// ******* Super admin dashboard list ************* //
export const superAdminDashboardItemList = [
    {
        id: 1,
        role: [1],
        name: 'Businesses',
        path: '/super-admin/all-businesses',
        icon: Companies
    },
    {
        id: 2,
        role: [1],
        name: 'Refer ReferUs',
        path: '/super-admin/refer-admin-referus',
        icon: ReferUS
    },
    {
        id: 3,
        role: [1],
        name: 'ReferUs Network',
        path: '/super-admin/referus-network',
        icon: Network
    },
    {
        id: 4,
        role: [1],
        name: 'Contact Us',
        path: '/super-admin/contact-us',
        icon: help
    },
    {
        id: 5,
        role: [1],
        name: 'SMS',
        path: '/super-admin/sms',
        icon: Sms
    },
    {
        id: 6,
        role: [1],
        name: 'My Referrers',
        path: '/super-admin/my-referrers',
        icon: MyReferrers
    },
    {
        id: 7,
        role: [1],
        name: 'My Referrals',
        path: '/super-admin/my-referrals',
        icon: Referrals
    },
    {
        id: 8,
        role: [1],
        name: 'Business Category',
        path: '/super-admin/business-category',
        icon: BusinessCategory
    },
    {
        id: 9,
        role: [1],
        name: 'Platform',
        path: '/super-admin/platform-list',
        icon: BusinessCategory
    },
]

export const businessCategories = [
    { "value": "accounting-and-bookkeeping", "label": "Accounting and bookkeeping" },
    { "value": "appliance-repair", "label": "Appliance repair" },
    { "value": "bakeries", "label": "Bakeries" },
    { "value": "beauticians", "label": "Beauticians" },
    { "value": "beauty-salons", "label": "Beauty salons" },
    { "value": "beauty-therapy", "label": "Beauty Therapy" },
    { "value": "bicycle-repair-shops", "label": "Bicycle repair shops" },
    { "value": "bookstores", "label": "Bookstores" },
    { "value": "builders", "label": "Builders" },
    { "value": "business-services", "label": "Business Services" },
    { "value": "car-dealerships", "label": "Car Dealerships" },
    { "value": "catering-services", "label": "Catering services" },
    { "value": "chiropractors-or-acupuncturists", "label": "Chiropractors or acupuncturists" },
    { "value": "clothing-stores", "label": "Clothing stores" },
    { "value": "coffee-shops-or-cafes", "label": "Coffee shops or cafés" },
    { "value": "counseling-or-therapy-practices", "label": "Counseling or therapy practices" },
    { "value": "craft-or-diy-workshops", "label": "Craft or DIY workshops" },
    { "value": "creative-and-arts", "label": "Creative and Arts" },
    { "value": "custom-furniture-or-carpentry", "label": "Custom furniture or carpentry" },
    { "value": "cybersecurity-consulting", "label": "Cybersecurity consulting" },
    { "value": "dance-or-art-studios", "label": "Dance or art studios" },
    { "value": "daycares-or-preschools", "label": "Daycares or preschools" },
    { "value": "day-spa", "label": "Day Spa" },
    { "value": "drone-services", "label": "Drone services (e.g., photography, surveying)" },
    { "value": "education-and-tutoring", "label": "Education and Tutoring" },
    { "value": "electrician", "label": "Electrician" },
    { "value": "entertainment-and-leisure", "label": "Entertainment and Leisure" },
    { "value": "entertainment-centers", "label": "Entertainment centers" },
    { "value": "event-planning-or-coordination", "label": "Event planning or coordination" },
    { "value": "fashion-retail", "label": "Fashion Retail" },
    { "value": "food-trucks", "label": "Food trucks" },
    { "value": "graphic-design-or-branding-studios", "label": "Graphic design or branding studios" },
    { "value": "gym-fitness-center", "label": "Gym/ Fitness Center" },
    { "value": "hairdressers", "label": "Hairdressers" },
    { "value": "handyman-services", "label": "Handyman services" },
    { "value": "home-and-maintenance", "label": "Home and Maintenance" },
    { "value": "house-cleaning-services", "label": "House cleaning services" },
    { "value": "interior-design-or-staging", "label": "Interior design or staging" },
    { "value": "it-hardware-repair", "label": "IT hardware repair (e.g., computers, phones)" },
    { "value": "it-support-or-tech-consulting", "label": "IT support or tech consulting" },
    { "value": "juice-and-smoothie-bars", "label": "Juice and smoothie bars" },
    { "value": "landscaping-and-lawn-care", "label": "Landscaping and lawn care" },
    { "value": "legal-services", "label": "Legal services (e.g., paralegals, notaries)" },
    { "value": "marketing-or-social-media-consulting", "label": "Marketing or social media consulting" },
    { "value": "massage-therapy-practices", "label": "Massage therapy practices" },
    { "value": "moving-companies", "label": "Moving companies" },
    { "value": "nail-salons", "label": "Nail salons" },
    { "value": "nutrition-consulting", "label": "Nutrition consulting" },
    { "value": "online-retail-stores", "label": "Online retail stores" },
    { "value": "painting-and-home-improvement", "label": "Painting and home improvement" },
    { "value": "personal-trainers-or-fitness-studios", "label": "Personal trainers or fitness studios" },
    { "value": "pet-grooming-services", "label": "Pet grooming services" },
    { "value": "photography-or-videography", "label": "Photography or videography" },
    { "value": "plumber", "label": "Plumber" },
    { "value": "restaurants", "label": "Restaurants" },
    { "value": "retail", "label": "Retail" },
    { "value": "rideshare-or-delivery-services", "label": "Rideshare or delivery services" },
    { "value": "solar-panel-installation", "label": "Solar panel installation" },
    { "value": "specialty-food-shops", "label": "Specialty food shops" },
    { "value": "technology", "label": "Technology" },
    { "value": "trade", "label": "Trade" },
    { "value": "transportation", "label": "Transportation" },
    { "value": "truck-dealerships", "label": "Truck Dealerships" },
    { "value": "vehicle-detailing-services", "label": "Vehicle detailing services" },
    { "value": "web-or-app-development", "label": "Web or app development" },
    { "value": "wellness-coaching", "label": "Wellness coaching" },
    { "value": "wholesaler", "label": "Wholesaler" },
    { "value": "yoga-or-pilates-studios", "label": "Yoga or Pilates studios" }
]
// [
//     { value: "accommodation-and-hotels", label: "Accommodation and hotels" },
//     { value: "agriculture", label: "Agriculture" },
//     { value: "arts-culture-entertainment", label: "Arts Culture, entertainment" },
//     { value: "construction", label: "Construction" },
//     { value: "education-and-training", label: "Education and training" },
//     { value: "fashion", label: "Fashion" },
//     { value: "financial-and-insurance", label: "Financial and insurance" },
//     { value: "fitness-and-sport", label: "Fitness and sport" },
//     { value: "gardening-and-lawmaking", label: "Gardening and Lawmaking" },
//     { value: "hairdressing", label: "Hairdressing" },
//     { value: "healthcare", label: "Healthcare" },
//     { value: "landscaping", label: "Landscaping" },
//     { value: "marketing-and-advertising", label: "Marketing and Advertising" },
//     { value: "mining", label: "Mining" },
//     { value: "ndis", label: "NDIS" },
//     { value: "plumbing", label: "Plumbing" },
//     { value: "retail-trade", label: "Retail Trade" },
//     { value: "security", label: "Security" },
//     { value: "tradie", label: "Tradie" },
//     { value: "wholesale-trade", label: "Wholesale trade" },
//     { value: "other", label: "other" }
//   ];

export const updatedBusinessServiceList = [
    {
      "label": "Retail",
      "value": "retail",
      "options": [
        { "label": "Boutique clothing stores", "value": "boutique_clothing_stores" },
        { "label": "Bottle shop", "value": "bottle_shop" },
        { "label": "Online retail stores", "value": "online_retail_stores" }
      ]
    },
    {
      "label": "Food and Beverage",
      "value": "food_and_beverage",
      "options": [
        { "label": "Coffee shops or cafés", "value": "coffee_shops" },
        { "label": "Food trucks", "value": "food_trucks" },
        { "label": "Bakeries", "value": "bakeries" },
        { "label": "Juice and smoothie bars", "value": "juice_smoothie_bars" },
        { "label": "Restaurants", "value": "restaurants" },
        { "label": "Catering services", "value": "catering_services" }
      ]
    },
    {
      "label": "Personal Services",
      "value": "personal_services",
      "options": [
        { "label": "Beauty salons or barber shops", "value": "beauty_salon" },
        { "label": "Nail salons", "value": "nail_salon" },
        { "label": "Massage therapy practices", "value": "massage_therapy" },
        { "label": "Personal trainers or fitness studios", "value": "personal_trainers" },
        { "label": "Pet grooming services", "value": "pet_grooming" },
        { "label": "House cleaning services", "value": "house_cleaning" },
        { "label": "Beauty Products", "value": "beauty_products" }
      ]
    },
    {
      "label": "Professional Services",
      "value": "professional_services",
      "options": [
        { "label": "Accounting and bookkeeping", "value": "accounting_bookkeeping" },
        { "label": "Marketing or social media consulting", "value": "marketing_consulting" },
        { "label": "IT support or tech consulting", "value": "it_support" },
        { "label": "Legal services", "value": "legal_services" },
        { "label": "Freelance writing, editing, or design services", "value": "freelance_services" },
        { "label": "Safety Consultants", "value": "safety_consultants" },
        { "label": "HR Consultants", "value": "hr_consultants" }
      ]
    },
    {
      "label": "Health and Wellness",
      "value": "health_and_wellness",
      "options": [
        { "label": "Yoga or Pilates studios", "value": "yoga_pilates" },
        { "label": "Counseling or therapy practices", "value": "counseling_therapy" },
        { "label": "Nutrition consulting", "value": "nutrition_consulting" },
        { "label": "Wellness coaching", "value": "wellness_coaching" },
        { "label": "Chiropractors or acupuncturists", "value": "chiropractors_acupuncturists" }
      ]
    },
    {
      "label": "Home and Maintenance",
      "value": "home_and_maintenance",
      "options": [
        { "label": "Landscaping and lawn care", "value": "landscaping_lawn_care" },
        { "label": "Handyman services", "value": "handyman_services" },
        { "label": "Painting and home improvement", "value": "painting_home_improvement" },
        { "label": "Interior design or staging", "value": "interior_design" },
        { "label": "Appliance repair", "value": "appliance_repair" },
        { "label": "Plumbers", "value": "plumbers" },
        { "label": "Builders", "value": "builders" },
        { "label": "Electricians", "value": "electricians" }
      ]
    },
    {
      "label": "Education and Tutoring",
      "value": "education_and_tutoring",
      "options": [
        { "label": "Private tutoring services", "value": "private_tutoring" },
        { "label": "Online course creation", "value": "online_course_creation" },
        { "label": "Music or art lessons", "value": "music_art_lessons" },
        { "label": "daycare's or preschools", "value": "decares_preschools" },
        { "label": "Test preparation services", "value": "test_preparation" }
      ]
    },
    {
      "label": "Entertainment and Leisure",
      "value": "entertainment_leisure",
      "options": [
        { "label": "Event planning or coordination", "value": "event_planning" },
        { "label": "Photography or videography", "value": "photography_videography" },
        { "label": "Specialty craft businesses", "value": "specialty_craft" },
        { "label": "Dance or art studios", "value": "dance_art_studios" },
        { "label": "Escape rooms or gaming centers", "value": "escape_rooms" }
      ]
    },
    {
      "label": "Transportation",
      "value": "transportation",
      "options": [
        { "label": "Rideshare or delivery services", "value": "rideshare_delivery" },
        { "label": "Moving companies", "value": "moving_companies" },
        { "label": "Bicycle repair shops", "value": "bicycle_repair" },
        { "label": "Vehicle detailing services", "value": "vehicle_detailing" },
        { "label": "Car dealerships", "value": "car_dealerships" }
      ]
    },
    {
      "label": "Technology",
      "value": "technology",
      "options": [
        { "label": "Web or app development", "value": "web_app_development" },
        { "label": "IT hardware repair", "value": "it_hardware_repair" },
        { "label": "Cybersecurity consulting", "value": "cybersecurity" },
        { "label": "Drone services", "value": "drone_services" }
      ]
    },
    {
      "label": "Green and Sustainable",
      "value": "green_sustainable",
      "options": [
        { "label": "Solar panel installation", "value": "solar_panel_installation" },
        { "label": "Recycling or upcycling businesses", "value": "recycling_upcycling" },
        { "label": "Urban farming or community gardens", "value": "urban_farming" },
        { "label": "Sustainable clothing brands", "value": "sustainable_clothing" }
      ]
    },
    {
      "label": "Creative and Arts",
      "value": "creative_arts",
      "options": [
        { "label": "Graphic design or branding studios", "value": "graphic_design" },
        { "label": "Custom furniture or carpentry", "value": "custom_furniture" },
        { "label": "Independent publishing", "value": "independent_publishing" }
      ]
    }
  ];

  export const rewardsList = [
    { value: "no-reward", label: "No Reward" },
    { value: "percentage", label: "% Commission" },
    { value: "cash", label: "Cash Reward" },
    { value: "coupon", label: "Voucher or Freebie" },
  ];

 export const advanceFilterList = [
    { value: 'all-selected',  label: "All Clients" },
    { value: "successful-clients", label: "Successful Clients" },
    { value: "unsuccessful-clients", label: "Unsuccessful Clients" },
    { value: "paid-offer", label: "Paid Offer" },
    { value: "outstanding-payees", label: "Outstanding Payees" },
    { value: "active", label: "Active" },
    { value: "deactivated", label: "Deactivated" },
  ];

  export const advanceFilterReferrerList = [
    { value: 'all-selected',  label: "All Clients" },
    { value: "successful-referrer", label: "Successful Clients" },
    { value: "unsuccessful-referrer", label: "Unsuccessful Clients" },
    { value: "paid-offer", label: "Paid Offer" },
    { value: "outstanding-referrer", label: "Outstanding Payees" },
    { value: "active", label: "Active" },
    { value: "deactivated", label: "Deactivated" },
  ];

  export const referralFilterList = [
    { value: 'all-selected',  label: "All Clients" },
    { value: "successful-clients", label: "Successful Clients" },
    { value: "unsuccessful-clients", label: "Unsuccessful Clients" },
    { value: "paid-offer", label: "Paid Offer" },
    { value: "outstanding-payees", label: "Outstanding Payees" },

  ];

  export const referReferUsFilter = [
    { value: 'all-selected',  label: "All" },
    { value: "company-i-refer", label: "Businesses I Refer" },
    { value: "all-company", label: "All Businesses" },
    { value: "paid-offer", label: "Paid Offers" },
    { value: "outstanding-payees", label: "Outstanding Payees" },
 ];

  export const advanceFilterReferUsList = [

    { value: "businessIRefer", label: "Business I Refer" },
  ];
  

  export const percentageList = [
    { value: "0", label: "0%" },
    { value: "5", label: "5%" },
    { value: "10", label: "10%" },
    { value: "15", label: "15%" },
    { value: "20", label: "20%" },
    { value: "25", label: "25%" },
    { value: "30", label: "30%" },
    { value: "35", label: "35%" },
    { value: "40", label: "40%" },
    { value: "45", label: "45%" },
    { value: "50", label: "50%" },
    { value: "55", label: "55%" },
    { value: "60", label: "60%" },
    { value: "65", label: "65%" },
    { value: "70", label: "70%" },
    { value: "75", label: "75%" },
    { value: "80", label: "80%" },
    { value: "85", label: "85%" },
    { value: "90", label: "90%" },
    { value: "95", label: "95%" },
    { value: "100", label: "100%" },
  ];

export const smsTypeList = [
    { label: "Business Setup", value: 'BusinessSetup' },
    // { label: "Invite Referrer", value: 'InviteReferrer' },
    { label: "Referrer SignUp", value: 'ReferrerSignUp' },
    { label: "Referrer Update Password", value: 'ReferrerUpdatePassword' },
    { label: "Send Referral", value: 'SendReferral' }
]